import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import Signup from '../Signup'

const SignupPage = () => {
  return (
    <>
    <ScrollToTop />
      <Signup />
    </>
  )
}

export default SignupPage
